import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate visitor legal documents.
 * Also refreshes visitor types, because their NDA steps embed the document.
 * Use this after creating, updating, or deleting a visitor document.
 */
export const useInvalidateVisitorDocuments = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ["visitorDocuments"] });
    await queryClient.invalidateQueries({ queryKey: ["visitorTypes"] });
  }, [queryClient]);
};
